<!-- Post -->



<!-- Post -->
<div class="wrapper">
  <div class="main-card">
    <div class="cards" >
      
      <div class="card">
        <div class="content">
          <!--New Cards -->

          
          
          
            <div class="row g-0">
              <div class="col-md-4">
                <img src="http://localhost:9091/Opportunity/{{ opportunity.image }}" alt="Post Picture" style="max-width: 100%; max-height: 600px; border-radius: 30px; -webkit-box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);
                box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2); margin-bottom: 10%;" >
                
              </div>
              <div class="col-md-8">
                <div class="card-body">
                  <h5 class="card-title"style="font-style: Poppins;">{{opportunity.title}}</h5>
                  <p class="card-text">{{opportunity.description}}</p><br>
                
            <div class="card-body">
              <h4>To connect with the owner </h4>
        
                  <p>Mobile : {{opportunity.numtlf}}<p>
                  
        <p>Or you can send mail to : <a target="_blank" href="{{opportunity.email}}">{{opportunity.email}}</a></p>
                      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                      <small style="transform:translateY(-300%);font-style: Poppins;">Published on : Published on : {{opportunity.date}} by {{ opportunity.user.nom }} {{ opportunity.user.prenom }} </small>
    
                
              </div>
            </div>
          </div>

          <br>
          <br>
          <!--Add Comment-->          
          <!--new style-->
        
          
        </div>
      </div>
    </div>
    
   
  </div>
  
  
     
      
    </div>
    
  </div>
  



           
     
  
  



















<!--

<div class="wrapper">
    <div class="main-card">
      <div class="cards" >
        <div class="card">
          <div class="content">
            
            <h1 class="post-title"style="font-size:70px;transform:translateY(-80%);font-style: Poppins;">{{opportunity.title}}</h1>
            <small style="transform:translateY(-300%);font-style: Poppins;">Published on : {{opportunity.date}}</small>
    
    
            <div class="img">
              <img src="http://localhost:9091/Opportunity/{{ opportunity.image }}" alt="Post Picture" style="max-width: 100%; max-height: 700px;"/>
            </div>
            <br>
            <h3 style="margin-left: 10%; margin-right: 10%; text-align: center; color: black; font-size: medium; font-family: Arial, Helvetica, sans-serif; text-indent: 5px;">{{opportunity.description}}</h3>
            <br>
            <div class="card-body">
              <h4>To connect with the owner </h4>
        
                  <h4>Mobile : {{opportunity.numtlf}}</h4>
                  
        <h5>Or you can send mail to : <a target="_blank" href="{{opportunity.email}}">{{opportunity.email}}</a></h5>
         
                </div>
    
          
    
    
    
            <br>
            <br>
            <!--Add Comment-->
           <!--
          </div>
        </div>
      </div>
    </div>
    
    <!--Comments-->
    <!-- <div class="container2"> -->
    
    <!-- </div> -->
    <!--Respons-->
    <!--<div class="main-card" *ngFor="let rep of listReponse">
      <div class="cards" >
        <div class="card">
          <div class="content">
            <li style="list-style-type: none; float: left; margin-left: -85%; margin-top: -20px;" >
              <img src="http://localhost:9091/User/{{ rep.user.profileImage }}" style="width: 30px; height: 30px; border-radius: 50%; border: 2px solid #5a54ff; display: inline;" alt="profile Image"/>
                <a class="nav-link">
                  <i class="ion-md-power" style="margin-left: -60%;"></i> {{rep.user.nom}} {{rep.user.prenom}}
                </a>
                <br>
            </li>
            <div class="details">
              <small>Published on : {{rep.date}}</small>
            <div class="name">
              <p>{{rep.description}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    
    <!--<div class="main-card">
      <div class="cards" >
        <div class="card">
          <div class="content">
            <li style="list-style-type: none; float: left; margin-left: -85%; margin-top: -20px;">
              <img src="http://localhost:9091/User/{{ user.profileImage }}" style="width: 30px; height: 30px; border-radius: 50%; border: 2px solid #5a54ff; display: inline;" alt="profile Image"/>
              <a class="nav-link" style="font-weight: bold; display: inline; color: black; margin-left: 0px; margin-bottom: 10px;">
                <i class="ion-md-power"></i> {{user.nom}} {{user.prenom}}
              </a>
              <br>
            </li>
            <br>
            <div class="form-group" *ngIf="comment">
              <input style="width: 90%; height: 40px; margin-left: 0px;" type="text" class="form-control" placeholder="Comment"[(ngModel)]="comment.description" required #description="ngModel"/>
              <button  class="btn btn-primary" style="height: 40px; margin-left: -20%;" (click)="addComment(comment)"> Send </button>
            </div>
            <br>
          </div>
        </div>
      </div>
    </div>-->
    
    
    